import { QueryObserverResult, useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { getActivityMetrics, getMetricsHistory } from '../api/monitoring';
import { HttpException } from '../common/models/httpException';
import { MetricResult, MetricsHistoryOverview } from '../modules/Monitoring/model/WeeklyStatisticsResponse';

export const CK_ACTIVITY_METRICS = 'activity-metrics';
export const CK_METRICS_HISTORY = 'metrics-history';

export const useActivityMetrics = (): QueryObserverResult<MetricResult[], AxiosError<HttpException>> =>
  useQuery([CK_ACTIVITY_METRICS], () => getActivityMetrics());

export const useMetricsHistory = (): QueryObserverResult<MetricsHistoryOverview, AxiosError<HttpException>> =>
  useQuery([CK_METRICS_HISTORY], () => getMetricsHistory());
